var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "outlined": ""
    }
  }, [_c('v-tabs', {
    model: {
      value: _vm.view,
      callback: function ($$v) {
        _vm.view = $$v;
      },
      expression: "view"
    }
  }, [_c('v-tab', [_vm._v(" 실시간 시청자 "), _c('span', {
    staticClass: "ml-4"
  }, [_vm._v(" (" + _vm._s(_vm.count) + ") ")])]), _c('v-tab', [_vm._v(" 시청 기록 ")])], 1), _c('v-divider'), _c('v-tabs-items', {
    model: {
      value: _vm.view,
      callback: function ($$v) {
        _vm.view = $$v;
      },
      expression: "view"
    }
  }, [_c('v-tab-item', [_c('meta-watcher')], 1), _c('v-tab-item', [_c('meta-watches', {
    attrs: {
      "isActive": _vm.view == 1
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }